import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Flex } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	container: {
		height: '162px',
		marginTop: token('space.200'),
	},
});

export const PlaylistLoadingView = () => {
	return (
		<Flex xcss={styles.container} justifyContent="center" alignItems="center">
			<Spinner size="medium" />
		</Flex>
	);
};
